import { render, staticRenderFns } from "./radStake.vue?vue&type=template&id=4cdbfd2f&scoped=true"
import script from "./radStake.vue?vue&type=script&lang=js"
export * from "./radStake.vue?vue&type=script&lang=js"
import style0 from "./radStake.vue?vue&type=style&index=0&id=4cdbfd2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdbfd2f",
  null
  
)

export default component.exports